import { AppState } from "@Safemate/Store/types";

export const getFilters = ({users: {filter}}: AppState) => filter;